// @flow
import React, { Fragment } from "react";
import Button from "../Button";
import styled from "styled-components";
import { post, normalPost } from "../../lib/Fetching";

const Container = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
`;

type Props = {
  sampleIds: Array<number>,
  company_id: ?number,
  onSampleUpdate: ?Function
};

export default class SchedulingListToolbar extends React.Component<Props> {
  static defaultProps = {
    sampleIds: []
  };

  canEdit = () => this.props.sampleIds.length > 0;

  scheduleSamples = () => {
    const { sampleIds } = this.props;
    const url = this._baseUrl() + "/scheduling/aliquot_schedules/create";
    normalPost(url, { sample_ids: sampleIds });
  };

  _baseUrl = () => {
    return window.location.protocol + "//" + window.location.host;
  };

  render() {
    const disabled = !this.canEdit();
    return (
      <Container>
        <Button tiny title="Schedule" disabled={disabled} onClick={this.scheduleSamples} />
      </Container>
    );
  }
}
